<template>
    <app-admin-layout :ask-for-quote="askForQuote">
        <Head>
            <title>{{ askForQuote.pfnumber }} - K-Anfrage</title>
        </Head>
        <div class="ask-for-quote ask-for-quote--client-quote">
            <ask-for-quote-header :askForQuote="askForQuote"/>

            <div class="ask-for-quote--content">
                <div class="container">
                    <div class="row">
                        <div class="col col-4">
                            <div class="row">
                                <div class="col">
                                    <card class="order-information">
                                        <card-header>
                                            <card-overline>Auftragsinformationen</card-overline>
                                        </card-header>
                                        <card-content>
                                            <description-group>
                                                <description-element :caption="askForQuote?.project_name"
                                                                   title="Projekttitel"/>
                                                <description-element :caption="askForQuote?.delivery_date" isDate="1"
                                                                   title="Wunschliefertermin"/>
                                                <description-element :caption="lotqty" title="Stückzahl"/>
                                                <description-element :caption="askForQuote?.internal_article_number"
                                                                   title="interne Artikelnr."/>
                                                <description-element :caption="askForQuote?.internal_ask_number"
                                                                   title="interne Anfragenr."/>
                                                <description-element :caption="askForQuote?.admin_user?.name" :title="askForQuote?.admin_user?.position"/>
                                            </description-group>
                                        </card-content>
                                    </card>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <form-actions>
                                        <form-button icon="delete-disabled" class="btn--block" color="error"
                                                     @click="rejectDialog = !rejectDialog" :disabled="disabledReject">Anfrage ablehnen
                                        </form-button>
                                    </form-actions>
                                    <client-quote-reject :askForQuote="askForQuote" v-if="rejectDialog" @closeDialog="rejectDialog = false" reject="quote" />
                                </div>
                            </div>
                        </div>
                        <div class="col col-8">
                            <form @submit.prevent="submit">
                                <div class="row">
                                    <div class="col col-6">
                                        <card>
                                            <card-header>
                                                <card-overline>Kundenzeichnung</card-overline>
                                            </card-header>
                                            <card-content>
                                                <form-drop-zone field="sketch_file" fileSize="2MB" fileType=".pdf"
                                                                maxFiles="1"
                                                                uploadTarget="ask-for-quote.client-quote.upload"
                                                                :data="{'askForQuote': askForQuote.id}"
                                                                :currentFile="clientSketchFile"
                                                                :error="errors.client_sketch_file"
                                                                @uploadedFiles="uploadedFiles">
                                                    <template v-slot:textDrag>
                                                        Legen Sie die PDF-Dateien hier ab<br/>&nbsp;
                                                    </template>
                                                    <template v-slot:textReplace>
                                                        Legen Sie die PDF-Dateien hier ab um die bestehende zu
                                                        ersetzen<br/>&nbsp;
                                                    </template>
                                                    <template v-slot:textdefault>
                                                        Hochzuladende PDF-Dateien hierhin ziehen<br/>
                                                        oder nach Dateien suchen (max. 2MB)
                                                    </template>
                                                </form-drop-zone>
                                                <form-drop-zone field="cad_file" renderType="simplefile" maxFilesize="4"
                                                                fileType=".step, .stp, .st, .dxf"
                                                                maxFiles="1"
                                                                uploadTarget="ask-for-quote.client-quote.upload"
                                                                :data="{'askForQuote': askForQuote.id}"
                                                                :currentFile="clientCadFile"
                                                                label="Neue Kundenzeichnung (3D)"
                                                                :error="errors.client_cad_file"
                                                                @uploadedFiles="uploadedFiles"/>
                                            </card-content>
                                        </card>
                                    </div>
                                    <div class="col col-6">
                                        <card>
                                            <card-header>
                                                <card-overline>Produzentenzeichnung</card-overline>
                                            </card-header>
                                            <card-content>
                                                <form-drop-zone field="sketch_file" fileSize="2MB" max-filesize="2" fileType=".pdf"
                                                                maxFiles="1"
                                                                uploadTarget="ask-for-quote.client-quote.upload"
                                                                :data="{'askForQuote': askForQuote.id, 'producer_file' : '1'}"
                                                                :currentFile="producerSketchFile"
                                                                info="Bitte Zeichnung hochladen"
                                                                :error="errors.producer_sketch_file"
                                                                @uploadedFiles="uploadedFiles">
                                                    <template v-slot:textDrag>
                                                        Legen Sie die PDF-Dateien hier ab<br/>&nbsp;
                                                    </template>
                                                    <template v-slot:textReplace>
                                                        Legen Sie die PDF-Dateien hier ab um die bestehende zu
                                                        ersetzen<br/>&nbsp;
                                                    </template>
                                                    <template v-slot:textdefault>
                                                        Hochzuladende PDF-Dateien hierhin ziehen<br/>
                                                        oder nach Dateien suchen (max. 2MB)
                                                    </template>
                                                </form-drop-zone>
                                                <form-drop-zone field="cad_file" renderType="simplefile" maxFilesize="4"
                                                                fileType=".step, .stp, .st, .dxf"
                                                                maxFiles="1"
                                                                uploadTarget="ask-for-quote.client-quote.upload"
                                                                :data="{'askForQuote': askForQuote.id, 'producer_file' : '1'}"
                                                                :currentFile="producerCadFile"
                                                                label="Neue Produzenzenzeichnung (3D)"
                                                                :error="errors.producer_cad_file"
                                                                @uploadedFiles="uploadedFiles"/>
                                            </card-content>
                                        </card>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col col-6">
                                        <card>
                                            <card-header>
                                                <card-overline>Historie</card-overline>
                                            </card-header>
                                            <card-content>
                                                <table class="table table--stripped table--card">
                                                    <thead>
                                                    <tr>
                                                        <th>Dateiname</th>
                                                        <th>Art</th>
                                                        <th class="text-right">Eingangsdatum</th>
                                                        <th></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="file in clientFiles" :key="file.index">
                                                        <td>{{ file?.file_informations?.original_name }}</td>
                                                        <td>{{ fileType(file.file_name) }}</td>
                                                        <td class="text-right">{{ fileDate(file.created_at) }} Uhr</td>
                                                        <td class="text-right">
                                                            <a :href="file.download"
                                                               class="btn btn--dense btn--icon-inline">
                                                                <svg-vue icon="documents-file-search" class="icon"/>
                                                            </a>
                                                            <a @click="deleteFileDialog = true; deleteFileRoute = file.delete"
                                                                  class="btn btn--dense btn--icon-inline">
                                                                <svg-vue icon="documents-file-delete-cross" class="icon"/>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </card-content>
                                        </card>
                                    </div>
                                    <div class="col col-6">
                                        <card>
                                            <card-header>
                                                <card-overline>Historie</card-overline>
                                            </card-header>
                                            <card-content>
                                                <table class="table table--stripped table--card">
                                                    <thead>
                                                    <tr>
                                                        <th>Dateiname</th>
                                                        <th>Art</th>
                                                        <th class="text-right">Eingangsdatum</th>
                                                        <th></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="file in producerFiles" :key="file.index">
                                                        <td>{{ file?.file_informations?.original_name }}</td>
                                                        <td>{{ fileType(file.file_name) }}</td>
                                                        <td class="text-right">{{ fileDate(file.created_at) }} Uhr</td>
                                                        <td class="text-right">
                                                            <a :href="file.download"
                                                               class="btn btn--dense btn--icon-inline">
                                                                <svg-vue icon="documents-file-search" class="icon"/>
                                                            </a>
                                                            <a @click="deleteFileDialog = true; deleteFileRoute = file.delete"
                                                               class="btn btn--dense btn--icon-inline">
                                                                <svg-vue icon="documents-file-delete-cross" class="icon"/>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </card-content>
                                        </card>
                                    </div>
                                    <modal-dialog title="Datei löschen" text="Möchten Sie die Datei wirklich löschen?" confirm="löschen" v-if="deleteFileDialog" @closeDialog="deleteFileDialog = false;" @confirmDialog="deleteFile" />
                                </div>
                                <div class="row row--sticky" v-sticky>
                                    <div class="col">
                                        <form-actions>
                                            <form-button type="submit" color="secondary"
                                                         icon="button-arrow-right-circle"
                                                         class="btn--block" :disabled="disabledTab || form.processing" :class="{'btn--processing': form.processing}">weiter
                                            </form-button>
                                        </form-actions>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-admin-layout>
</template>

<script>

import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import AskForQuoteHeader from './Header/AskForQuoteHeader';
import FormDropZone from '@partfactory/Shared/Form/FormDropZone';
import FormButton from '@partfactory/Shared/Form/FormButton';
import moment from 'moment';
import {useForm} from '@inertiajs/vue3';
import FormActions from '@partfactory/Shared/Form/FormActions';
import ClientQuoteReject from '@partfactory/Pages/Admin/AskForQuote/Modals/ClientQuoteReject';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import ModalDialog from '@partfactory/Shared/Modal/ModalDialog';

export default {
    name: 'ClientQuote',
    components: {
        ModalDialog,
        DescriptionElement,
        ClientQuoteReject,
        FormActions,
        FormButton,
        FormDropZone,
        AskForQuoteHeader, DescriptionGroup, CardHeader, CardOverline, CardContent, Card, AppAdminLayout
    },
    props: {
        askForQuote: Object,
        errors: Object,
    },
    data() {
        let rejectDialog = false, deleteFileDialog = false, deleteFileRoute = null;
        const form = useForm({});
        return {rejectDialog, deleteFileDialog, deleteFileRoute, form};
    },
    mounted() {
        this.fileHandler();
    },
    computed: {
        lotqty() {
            let lotqty = [];
            lotqty.push(this?.askForQuote?.lotqty_1);
            this?.askForQuote?.lotqty_2 ? lotqty.push(this?.askForQuote?.lotqty_2) : '';
            this?.askForQuote?.lotqty_3 ? lotqty.push(this?.askForQuote?.lotqty_3) : '';
            this?.askForQuote?.lotqty_4 ? lotqty.push(this?.askForQuote?.lotqty_4) : '';

            return lotqty.join(' | ');
        },
        clientSketchFile() {
            let sketchFile = null;
            this.askForQuote.sketch_files.forEach(file => {
                if (file.client_file)
                    sketchFile = !sketchFile ? file : sketchFile;
            });
            return sketchFile;
        },
        clientCadFile() {
            let cadFile = null;
            this.askForQuote.cad_files.forEach(file => {
                if (file.client_file)
                    cadFile = !cadFile ? file : cadFile;
            });
            return cadFile;
        },
        clientFiles() {
            let clientFiles = [];

            this.fileHandler();

            this.askForQuote.sketch_files.forEach(file => {
                if (file.client_file)
                    clientFiles.push(file);
            });
            this.askForQuote.cad_files.forEach(file => {
                if (file.client_file)
                    clientFiles.push(file);
            });

            return clientFiles;
        },
        producerSketchFile() {
            let sketchFile = null;
            this.askForQuote.sketch_files.forEach(file => {
                if (!file.client_file)
                    sketchFile = !sketchFile ? file : sketchFile;
            });
            return sketchFile;
        },
        producerCadFile() {
            let cadFile = null;
            this.askForQuote.cad_files.forEach(file => {
                if (!file.client_file)
                    cadFile = !cadFile ? file : cadFile;
            });
            return cadFile;
        },
        producerFiles() {
            let producerFiles = [];

            this.fileHandler();

            this.askForQuote.sketch_files.forEach(file => {
                if (!file.client_file)
                    producerFiles.push(file);
            });
            this.askForQuote.cad_files.forEach(file => {
                if (!file.client_file)
                    producerFiles.push(file);
            });

            return producerFiles;
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 1);
        },
        disabledReject() {
            return this.$disabledTab(this.askForQuote.status, 5);
        }
    },
    methods: {
        fileDate(fileDate) {
            return moment(String(fileDate)).format('DD.MM.YYYY, HH:mm');
        },
        fileType(fileName) {
            return fileName.split('.').pop().toUpperCase();
        },
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.client-quote.post', {'askForQuote': this.askForQuote.id}), {});
        },
        fileHandler() {
            this.askForQuote.sketch_files.forEach(file => {
                file.download = this.$$route('sketch-file.download', {'sketchFile': file.id});
                file.delete = this.$$route('sketch-file.delete', {'sketchFile': file.id});
            });
            this.askForQuote.cad_files.forEach(file => {
                file.download = this.$$route('cad-file.download', {'cadFile': file.id});
                file.delete = this.$$route('cad-file.delete', {'cadFile': file.id});
            });
        },
        uploadedFiles() {
            this.$inertia.reload();
        },
        deleteFile() {
            this.$inertia.delete(this.deleteFileRoute);
            this.deleteFileRoute = null;
            this.deleteFileDialog = false;
        }
    },
};
</script>

